(() => {
  let loading = false;
  let script = null;

  function loadRatingBars() {
    if (loading || !document.querySelector('.reviews-io-rating-bar-widget:not([data-mounted])')) return;
    loading = true;
    script?.remove();
    script = document.createElement('script');
    script.src = 'https://widget.reviews.io/modern-widgets/rating-bar.js';
    script.async = true;
    script.addEventListener('load', () => { loading = false; });
    script.addEventListener('error', () => { loading = false; });
    document.head.appendChild(script);
  }

  loadRatingBars();
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', loadRatingBars);
  }
})();
